import React from 'react'
import ReactDOM from 'react-dom'
import './index.scss'
import App from './Containers/App'
import * as serviceWorker from './serviceWorker'
import WebFont from 'webfontloader'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faBroom,
  faIndustry,
  faFileSignature,
  faLink,
  faUndo,
  faHandshake,
  faRuler,
  faCameraRetro
} from '@fortawesome/free-solid-svg-icons'
import {
  faOwnSimpleHouse,
  faOwnChimney,
  faOwnAnalytics,
  faOwnVentilation,
  faOwnRope,
  faOwnInstallation,
  faOwnEnvironment,
  faOwnMechanical
} from './Assets/svg/Icons'

library.add(
  faBroom,
  faIndustry,
  faOwnSimpleHouse,
  faFileSignature,
  faOwnChimney,
  faLink,
  faUndo,
  faHandshake,
  faOwnAnalytics,
  faRuler,
  faCameraRetro,
  faOwnVentilation,
  faOwnRope,
  faOwnInstallation,
  faOwnEnvironment,
  faOwnMechanical
)

WebFont.load({
  google: {
    families: ['Lato:300,400,700,900']
  }
})

ReactDOM.render(<App />, document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
